var $223cc8f6bb1d23dd$exports = {};
$223cc8f6bb1d23dd$exports = {
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`
};


export {$223cc8f6bb1d23dd$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
